(() => {
  async function updateDrawer(url, body) {
    const res = await fetch(url, {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({
        ...body,
        sections:'cart-drawer,cart-icon-bubble',
        sections_url:location.pathname
      })
    });
    if(!res.ok) throw new Error('Cart update failed.');
    const data = await res.json();
    const drawer = document.querySelector('cart-drawer');
    if(drawer && typeof drawer.renderContents === 'function') drawer.renderContents(data);
    else location.reload();
  }

  document.addEventListener('change', async e => {
    const cb = e.target.closest('[data-usvora-protection]');
    if(!cb) return;
    const id = cb.dataset.variantId;
    const key = cb.dataset.lineKey;
    if(!id || id === '0'){
      cb.checked = false;
      alert('Add your Shipping Protection variant ID first.');
      return;
    }
    cb.disabled = true;
    try{
      if(cb.checked){
        await updateDrawer('/cart/add.js',{items:[{id:Number(id),quantity:1}]});
      }else{
        await updateDrawer('/cart/change.js',{id:key,quantity:0});
      }
    }catch(err){
      cb.checked = !cb.checked;
      alert(err.message);
    }finally{
      cb.disabled = false;
    }
  });
})();
